export default "__VITE_ASSET__Boz1YXWM__"